module.exports = __webpack_public_path__ + "static/media/carousel_1.aa4fec02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/carousel_1.jpg
// module id = 165
// module chunks = 0